import { render, staticRenderFns } from "./RightNav.v2.vue?vue&type=template&id=5bd8b768&"
import script from "./RightNav.v2.vue?vue&type=script&lang=js&"
export * from "./RightNav.v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports